import { useTranslation } from "react-i18next";
import { InlineDiv } from "@/common/divs";
import { SemiBoldText } from "@/common/texts";

interface ShowPriceProps {
  price: string;
}

const ShowPrice: React.FC<ShowPriceProps> = ({ price }) => {
  const { t } = useTranslation();

  return (
    <InlineDiv
      width="482px"
      paddingY="16px"
      paddingX="25px"
      className="select-tariff-container"
      style={{
        justifyContent: "end",
        gap: "20px",
      }}
    >
      <SemiBoldText fontSize="18px">
        {t("select_price_lines.total_price")}:
      </SemiBoldText>
      <SemiBoldText fontSize="18px">{price.replace(".", ",")} €</SemiBoldText>
    </InlineDiv>
  );
};
export default ShowPrice;
